import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../../store/actions/notificationAction';
import { receiveServicesAndTariff } from '../../../../store/actions/addServiceAndTariffAction';

import pickupOrderRemote from '../../../../api/pickupOrderRemote';
import paymentRemote from '../../../../api/paymentsRemote';

import PaymentsTable from './PaymentsTable';
import PaymentsStatus from './PaymentStatus';
import PaymentDetailsModal from './PaymentDetailsModal';

import AwbParams from '../../../../models/AwbParams';
import ApiResponse from '../../../../models/ApiResponse';
import ResponseError from '../../../../models/ResponseError';
import GhaPoAwbsPayments from '../../../../models/GhaPoAwbsPayments';
import GhaPoAwbPaymentsStatus from '../../../../models/GhaPoAwbPaymentsStatus';
import GhaPoAwbPayments from '../../../../models/GhaPoAwbPayments';
import PaymentsDetail from '../../../../models/PaymentDetails';
import AddServicesTariff from '../../../../models/AddServicesTariff';
import ConfirmationDialog from '../../../confirmation/ConfirmationDialog';

import { extractAwbCodeAndNumber } from '../../../../utils/airwayBill';

import paymentsTableStyles from './payments.module.css';
import commonStyles from '../../../common/common.module.css';

interface PaymentsContainerProps {
  selectedPoNumber: string;
  awbNo: string;
  awbVer: number;
  weight: number;
  additionalService: AddServicesTariff;
  receiveError: Function;
  handleCommonResponsePayed: (poNumber: string, awbCode: string, awbNumber: string, ver: number) => void;
  getServicesAndTariff: (code: string, number: string, ver: number, isExport?: boolean, poNumber?: string) => void;
  triggerAwbsUpdate: any;
};

interface PaymentsContainerState {
  payments: GhaPoAwbsPayments;
  status: Array<GhaPoAwbPaymentsStatus>;
  isModalOpen: boolean;
  paymentDetail: PaymentsDetail;
  paidStatus: string;
  disabled: boolean;
  reason: string;
  id: number;
  confirmationOpen: boolean;
  textConfirm: string;
};

class PaymentsContainer extends Component<PaymentsContainerProps, PaymentsContainerState> {

  state: PaymentsContainerState = {
    payments: {
      payments: [
        {
          id: -1,
          id_payment_awb: -1,
          due: 0,
          paid: 0,
          service: ''
        }
      ],
      totalDue: 0,
      totalPaid: 0,
      totalPending: 0
    },
    status: [],
    isModalOpen: false,
    paymentDetail: {
      first_name: '',
	    last_name : '',
	    payment_info: '',
	    payment_type_name: '',
	    status: '',
      total_amount: -1,
      awbs: [],
      allowed_ops: {
        status_update: false
      }
    },
    paidStatus: '',
    disabled: false,
    reason: '',
    id: 0,
    confirmationOpen: false,
    textConfirm: ''
  }

  componentDidMount() {

    this.commonLoad();
  }

  componentDidUpdate(prevProps: PaymentsContainerProps) {

    if (this.props.awbNo !== prevProps.awbNo || this.props.selectedPoNumber !== prevProps.selectedPoNumber) {

      this.commonLoad();
    }
  }

  commonLoad = (): void => {

    const awbParams: AwbParams = extractAwbCodeAndNumber(this.props.awbNo);
    this.loadAwbPayments(this.props.selectedPoNumber, awbParams.awbCode, awbParams.awbNumber, awbParams.version);
    this.loadAwbPaymentsStatus(awbParams.awbCode, awbParams.awbNumber, awbParams.version);
    this.props.getServicesAndTariff(awbParams.awbCode, awbParams.awbNumber, this.props.awbVer, undefined, this.props.selectedPoNumber);
  }

  loadAwbPayments = (poNumber: string, awbCode: string, awbNumber: string, ver: number): void => {

    pickupOrderRemote.getGhaPoAwbsPayments(poNumber, awbCode, awbNumber, ver).then((resp: ApiResponse<GhaPoAwbsPayments>) => {

      const payments: GhaPoAwbsPayments | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (payments) {
        this.setState({ payments });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  loadAwbPaymentsStatus = (awbCode: string, awbNumber: string, ver: number): void => {

    paymentRemote.getGhaPoAwbPaymentsStatus( [{code: awbCode, number: awbNumber, version: ver}], this.props.selectedPoNumber ).then((resp: ApiResponse<GhaPoAwbPayments>) => {

      const payments: GhaPoAwbPayments| undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (payments) {
        const status: GhaPoAwbPaymentsStatus[] = payments.payments;
        this.setState({ status });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  openModal = (id: number): void => {
    
    this.setState({ id });
    paymentRemote.getPaymentDetails(id, this.props.selectedPoNumber).then((resp: ApiResponse<PaymentsDetail>) => {
 
      const paymentDetail: PaymentsDetail | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (paymentDetail) {

        const paidStatus: string = paymentDetail.status;
        const disabled: boolean = paidStatus !== 'pending';

        this.setState({ isModalOpen: true, paidStatus, disabled, paymentDetail });
      }

      if (error) {
        this.props.receiveError(error);
      };
    }); 
  }

  handleClose = (): void => {

    this.setState({ isModalOpen: false, id: 0 });
  }

  handleSave = (): void => {

    this.setState({ confirmationOpen: true });
  }

  handleSaveConfirm = (): void => {

    const id: number = this.state.id;
    const data: { status: string, reason: string } = {
      status: this.state.paidStatus,
      reason: this.state.reason
    };

    paymentRemote.setPaymentStatus(id, data, this.props.selectedPoNumber).then((resp: ApiResponse<boolean>) => {

      const success: boolean | undefined = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (success) {

        this.commonLoad();
        this.props.triggerAwbsUpdate()
        const awbParams: AwbParams = extractAwbCodeAndNumber(this.props.awbNo);

        this.props.handleCommonResponsePayed(this.props.selectedPoNumber, awbParams.awbCode, awbParams.awbNumber, this.props.awbVer);
        
        this.setState({ isModalOpen: false, confirmationOpen: false });
      };

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  handleChange = (event: any): void => {

    const paidStatus: string = event.target.value;
    let reason: string = this.state.reason;
    switch (paidStatus) {
      case 'confirmed' : 
        this.setState({ textConfirm: 'Do you really want to confirm this payment has been done? To confirm, press again button “Save”, to cancel use “X” icon.'});
        break;
      case 'canceled' :
        this.setState({ textConfirm: 'Do you really want to set the status of this payment to “Not Confirmed”? To set “Not Confirmed”, press again button “Save”, to cancel use “X” icon'});
        break;
      default: 
        this.setState({ textConfirm: ''});
     };

    if (paidStatus !== 'confirmed') {
      
      reason = '';
    }
    this.setState({ paidStatus, reason });
  }

  onChangeReason = (event: any): void => {

    const reason: string = event.target.value;

    this.setState({ reason });
  }

  handleCloseConfirmationDialog = (): void => {
    const textConfirm = this.state.paidStatus == 'confirmed' ? this.state.textConfirm : '';
    this.setState({
      confirmationOpen: false,
      textConfirm
    });
  }
 
  render () {

    return (

      <div className={ `${ commonStyles.wrapper } ${ commonStyles.h100 }` } >

        <h3 className={ `${ commonStyles.header }` } >Payments</h3>
        <PaymentsTable payments={ this.state.payments } />
        <PaymentsStatus status={ this.state.status } openModal={ this.openModal } />
        { this.state.isModalOpen && 
          <PaymentDetailsModal 
            modalOpen={ this.state.isModalOpen }
            handleClose={ this.handleClose }
            handleSave={ this.handleSave }
            payments={ this.state.paymentDetail }
            addServicesTariff={ this.props.additionalService }
            status={ this.state.paidStatus }
            handleChange={ this.handleChange }
            disabled={ this.state.disabled ||  !this.state.paymentDetail.allowed_ops.status_update}
            reason={ this.state.reason }
            onChangeReason={ this.onChangeReason }
            weight={ this.props.weight }
          />
        }
        { this.state.confirmationOpen && 
          <ConfirmationDialog
            open={ this.state.confirmationOpen }
            title=''
            text={ this.state.textConfirm }
            close= {this.handleCloseConfirmationDialog }
            confirm={ this.handleSaveConfirm }
            textConfirm='Save'
            showCloseIcon={ true }
          />
        }
      </div>
    );
  }
}
const mapStateToProps = (state: any) => {
  return {
    additionalService: state.additionalService
  };
};
const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    getServicesAndTariff: (awbCode: string, awbNumber: string, ver: number, isExport?: boolean, poNumber?: string) => dispatch(receiveServicesAndTariff(awbCode, awbNumber, ver, undefined, poNumber))
  };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(PaymentsContainer);